export class BoardAnnotationsIdentifier {
    public static ChecklistAnnotation: string = "Microsoft.VSTS.Agile.ChecklistAnnotation";
    public static GitHubLinksAnnotation: string = "Microsoft.VSTS.Boards.GitHubLinksAnnotation";
    public static TestAnnotation: string = "Microsoft.VSTS.TestManagement.TestAnnotation";
    public static CardAnnotation: string = "Microsoft.VSTS.Agile.{0}Annotation";
}
